const SEASONS = ["spring", "summer", "autumn", "winter"];

const QUESTIONS = [
    {
        id: "undertone",
        title: "Jaki odcień ma Twoja skóra w świetle dziennym?",
        hint: "Spójrz na skórę bez makijażu, najlepiej przy oknie.",
        answers: [
            { id: "warm", label: "Brzoskwiniowy, złocisty lub żółtawy", scores: { spring: 2, autumn: 2 } },
            { id: "cool", label: "Różowy, niebieskawy lub porcelanowy", scores: { summer: 2, winter: 2 } },
            { id: "neutral", label: "Trudno określić — raczej neutralny", scores: { spring: 1, summer: 1, autumn: 1, winter: 1 } },
        ],
    },
    {
        id: "veins",
        title: "Jaki kolor mają żyłki na wewnętrznej stronie nadgarstka?",
        hint: "Oceń je w naturalnym świetle, bez kolorowego oświetlenia.",
        answers: [
            { id: "green", label: "Zielony lub oliwkowy", scores: { spring: 2, autumn: 2 } },
            { id: "blue", label: "Niebieski lub fioletowy", scores: { summer: 2, winter: 2 } },
            { id: "mixed", label: "Widzę zarówno zielone, jak i niebieskie", scores: { spring: 1, summer: 1, autumn: 1, winter: 1 } },
        ],
    },
    {
        id: "jewelry",
        title: "Która biżuteria lepiej rozświetla Twoją twarz?",
        hint: "Przyłóż złoto i srebro blisko twarzy i porównaj efekt.",
        answers: [
            { id: "gold", label: "Złota", scores: { spring: 2, autumn: 2 } },
            { id: "silver", label: "Srebrna", scores: { summer: 2, winter: 2 } },
            { id: "both", label: "Obie wyglądają podobnie dobrze", scores: { spring: 1, summer: 1, autumn: 1, winter: 1 } },
        ],
    },
    {
        id: "hair",
        title: "Jak wyglądają Twoje naturalne włosy?",
        hint: "Bierz pod uwagę kolor bez farbowania i ton widoczny w słońcu.",
        answers: [
            { id: "light-warm", label: "Jasne, złociste, miodowe lub jasnorude", scores: { spring: 4, autumn: 1 } },
            { id: "soft-cool", label: "Popielaty blond, mysi blond lub chłodny jasny brąz", scores: { summer: 4, winter: 1 } },
            { id: "deep-warm", label: "Rude, kasztanowe, czekoladowe lub z miedzianym refleksem", scores: { autumn: 4, spring: 1 } },
            { id: "deep-cool", label: "Ciemny brąz lub czerń bez złotych refleksów", scores: { winter: 4, summer: 1 } },
        ],
    },
    {
        id: "eyes",
        title: "Który opis najlepiej pasuje do Twoich oczu?",
        hint: "Zwróć uwagę na dominujący kolor i wyrazistość tęczówki.",
        answers: [
            { id: "clear-light", label: "Jasne i czyste: błękitne, zielone lub jasnopiwne", scores: { spring: 4, summer: 1 } },
            { id: "soft-muted", label: "Zgaszone: szaroniebieskie, szarozielone lub miękkie piwne", scores: { summer: 4, autumn: 1 } },
            { id: "warm-deep", label: "Ciepłe: bursztynowe, oliwkowe, orzechowe lub ciepłobrązowe", scores: { autumn: 4, spring: 1 } },
            { id: "clear-deep", label: "Wyraziste i kontrastowe: ciemnobrązowe, czarne, kobaltowe", scores: { winter: 4, summer: 1 } },
        ],
    },
    {
        id: "contrast",
        title: "Jaki jest naturalny kontrast między skórą, włosami i oczami?",
        hint: "Wyobraź sobie swoje zdjęcie w czerni i bieli.",
        answers: [
            { id: "light-clear", label: "Jasny i świeży — wszystko jest raczej delikatne, ale świetliste", scores: { spring: 4 } },
            { id: "low-soft", label: "Niski i zgaszony — kolory płynnie przechodzą jeden w drugi", scores: { summer: 4 } },
            { id: "medium-warm", label: "Średni lub głęboki, z wyraźnym ciepłem", scores: { autumn: 4 } },
            { id: "high", label: "Wysoki — np. jasna skóra i bardzo ciemne włosy", scores: { winter: 4 } },
        ],
    },
    {
        id: "neutral-test",
        title: "Który zestaw neutralnych kolorów wygląda przy twarzy najlepiej?",
        hint: "Jeśli możesz, przyłóż do twarzy tkaniny lub ubrania w tych kolorach.",
        answers: [
            { id: "cream-camel", label: "Krem, jasny camel i ciepły beż", scores: { spring: 4, autumn: 1 } },
            { id: "soft-grey", label: "Gołębia szarość, złamana biel i chłodny taupe", scores: { summer: 4 } },
            { id: "brown-olive", label: "Czekoladowy brąz, oliwka i głęboki camel", scores: { autumn: 4, spring: 1 } },
            { id: "black-white", label: "Czysta biel, czerń i chłodny granat", scores: { winter: 4 } },
        ],
    },
    {
        id: "best-colors",
        title: "W której grupie kolorów najczęściej słyszysz: „świetnie wyglądasz”?",
        hint: "Wybierz efekt, który widzisz przy twarzy, nie tylko ulubione kolory.",
        answers: [
            { id: "fresh", label: "Koral, brzoskwinia, świeża zieleń, turkus", scores: { spring: 6 } },
            { id: "pastel", label: "Pudrowy róż, lawenda, denim, chłodny błękit", scores: { summer: 6 } },
            { id: "earth", label: "Terakota, musztarda, rdzawy, khaki", scores: { autumn: 6 } },
            { id: "jewel", label: "Fuksja, kobalt, szmaragd, śnieżna biel", scores: { winter: 6 } },
        ],
    },
];

const RESULT_DATA = {
    spring: {
        name: "Wiosna",
        tone: "Ciepła, jasna i świeża",
        summary: "Najbardziej harmonizują z Tobą świetliste, ciepłe i czyste kolory, które dodają cerze energii.",
        colors: ["#ff7655", "#f59a67", "#f9c24f", "#aaca67", "#73bd91", "#54b7c6"],
        neutrals: ["krem", "ecru", "jasny camel", "ciepły beż"],
        avoid: ["głęboka czerń", "stalowa szarość", "bardzo zgaszone barwy"],
    },
    summer: {
        name: "Lato",
        tone: "Chłodna, jasna i stonowana",
        summary: "Twoją delikatną urodę podkreślają miękkie, chłodne i lekko przygaszone kolory bez ostrych kontrastów.",
        colors: ["#df8fab", "#c3a5ce", "#aebcda", "#7fa9c9", "#7fa296", "#c8c4c5"],
        neutrals: ["gołębia szarość", "złamana biel", "chłodny taupe", "granat denimowy"],
        avoid: ["neonowy pomarańcz", "smolista czerń przy twarzy", "ostre ciepłe kontrasty"],
    },
    autumn: {
        name: "Jesień",
        tone: "Ciepła, głęboka i złota",
        summary: "Najlepiej współgrają z Tobą nasycone barwy ziemi, ciepłe tony i bogate, naturalne zestawienia.",
        colors: ["#778d18", "#d69608", "#e7780b", "#bd5114", "#923d20", "#176d70"],
        neutrals: ["czekoladowy brąz", "camel", "oliwka", "ciepły krem"],
        avoid: ["lodowe pastele", "chłodny jasny róż", "optyczna biel"],
    },
    winter: {
        name: "Zima",
        tone: "Chłodna, kontrastowa i wyrazista",
        summary: "Twoja uroda zyskuje w czystych, chłodnych i mocnych kolorach oraz zdecydowanych kontrastach.",
        colors: ["#d40b68", "#405eb1", "#2da3a5", "#263d43", "#171a1d", "#f5f5f2"],
        neutrals: ["czysta biel", "czerń", "chłodny granat", "grafit"],
        avoid: ["zgaszony camel", "ciepłe beże", "przydymione pastele"],
    },
};

function calculateColorSeason(answerIds) {
    const scores = SEASONS.reduce((acc, season) => ({ ...acc, [season]: 0 }), {});
    QUESTIONS.forEach((question, index) => {
        const answer = question.answers.find((item) => item.id === answerIds[index]);
        if (!answer) return;
        Object.entries(answer.scores).forEach(([season, points]) => { scores[season] += points; });
    });
    const ranking = SEASONS.slice().sort((a, b) => scores[b] - scores[a] || SEASONS.indexOf(a) - SEASONS.indexOf(b));
    const winner = ranking[0];
    const runnerUp = ranking[1];
    const answered = answerIds.filter(Boolean).length;
    const gap = scores[winner] - scores[runnerUp];
    const confidence = Math.min(96, Math.max(50, 54 + gap * 4 + Math.max(0, answered - 6) * 2));
    return { season: winner, runnerUp, confidence, scores, answered, ...RESULT_DATA[winner] };
}

module.exports = { QUESTIONS, RESULT_DATA, calculateColorSeason };
